/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorReplacementModel } from '../../models/patient-behavior-replacement-model';

export interface SavePatientBehaviorReplacement$Params {
      body?: PatientBehaviorReplacementModel
}

export function SavePatientBehaviorReplacement(http: HttpClient, rootUrl: string, params?: SavePatientBehaviorReplacement$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorReplacementModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientBehaviorReplacement.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientBehaviorReplacementModel>;
    })
  );
}

SavePatientBehaviorReplacement.PATH = '/api/Staff/SavePatientBehaviorReplacement';
